import { useDispatch } from 'react-redux';
import {
	Col,
	Alert,
	Spinner,
	CardBody,
	Card,
	CardHeader,
	Row,
} from 'reactstrap';
import { useNavigate, Link } from 'react-router-dom';
import { createSelector } from 'reselect';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import { ODataGrid } from '../../Components/OElements/ODataGrid.js';
import { getPersonAssignedItemsSummary, getPersonAssignedItemsSummaryQuery } from '../../slices/thunks';
import { useUser } from '../../Components/Hooks/useUserHooks.js';

const PersonalProtectiveEquipmentSupplyList = () => {
	const dispatch = useDispatch();
	const history = useNavigate();
	const { user } = useUser();


	const selectorCategories = createSelector(
		state => state.PersonalProtectiveEquipments,
		data => ({
			dataList: data.personalProtectiveEquipmentList,
			isLoadingList: data.isLoadingList,
			isPersonalProtectiveEquipmentSuccess: data.isPersonalProtectiveEquipmentSuccess,
		})
	);

	const { dataList, isLoadingList } = useSelector(selectorCategories);

	useEffect(() => {
		dispatch(getPersonAssignedItemsSummaryQuery());
	}, []);


	const columns = useMemo(
		() => [
			{
				header: 'Código',
				accessorKey: 'code',
				size: 'auto',
				dataType: 'multi-select',
				defaultSort: 'desc',  // Orden descendente por defecto
			},
			{
				header: 'Estado',
				accessorKey: 'personal_protective_equipment_status.name',
				size: 'auto',
				Cell: ({ row }) => {
					let status = row.original.personal_protective_equipment_status
					let bgColor = status?.bgcolor;
					let txColor = status?.txcolor;
					return (
						<div>
							<span className={`badge`} style={{ backgroundColor: bgColor, color: txColor }}>
								{status
									? status.name
									: ''}
							</span>
						</div>
					);
				},
				dataType: 'multi-select',
			},
			{ header: 'Rut', accessorKey: 'person.rut', size: 'auto', },
			{ header: 'Persona', accessorKey: 'person.name', size: 'auto', },
			{ header: 'Centro Costo', accessorKey: 'person.cost_center.code', size: 'auto', dataType: 'multi-select', },
			{ header: 'Departamento', accessorKey: 'person.management.name', size: 'auto', dataType: 'multi-select', },
			{ header: 'Establecimiento', accessorKey: 'establishment.name', size: 'auto', dataType: 'multi-select', },
			{ header: 'Asignación', accessorKey: 'assignment_date', dataType: 'date', size: 'auto' },
			{ header: 'Entrega', accessorKey: 'delivery_date', dataType: 'date', size: 'auto', },
		{
			header: 'Nro Guía',
			accessorKey: 'pick_document_number',
			size: 'auto',
			Cell: ({ row }) => {
				const guideNumber = row.original.pick_document_number;
				
				// Si no tiene número de guía, mostrar guión
				if (!guideNumber || guideNumber === '-') {
					return '-';
				}
				
				// Siempre hacer clickeable si tenemos un número de guía
				// La ruta /warehouse/guides/{folio} funciona con o sin guide_id
				return (
					<Link 
						to={`/warehouse/guides/${guideNumber}`}
						className="text-primary fw-bold"
						style={{ textDecoration: 'none', cursor: 'pointer' }}
						title={`Ver guía #${guideNumber}`}
					>
						#{guideNumber}
					</Link>
				);
			},
		},
			{ header: 'Devuelto', accessorKey: 'return_date', dataType: 'date', size: 'auto', },
			{ header: 'Recepcionado', accessorKey: 'receive_date', dataType: 'date', size: 'auto', },
			{ header: 'Elemento', accessorKey: 'assigned_items.name', size: 'auto' },
			{ header: 'Cantidad', accessorKey: 'assigned_items.quantity', size: 'auto', },
			{ header: 'Unidad', accessorKey: 'assigned_items.unit_measurement_name', size: 'auto', },
			{ header: 'Motivo', accessorKey: 'personal_protective_equipment_reason.name', size: 'auto', dataType: 'multi-select', },
			{ header: 'Doc Num', accessorKey: 'doc_num', size: 'auto', },
			{ header: 'Doc Entry', accessorKey: 'doc_entry', size: 'auto', },
		],
	);

	return (
		<React.Fragment>
			<Row>
				<Col lg={12}>
					<Card>

						<CardBody>
							<ODataGrid
								columns={columns}
								getDataFunc={getPersonAssignedItemsSummaryQuery}
								queryPopulate={[
									// 'person',
									// 'cost_center',
									'establishment',
									'personal_protective_equipment_reason',
									'personal_protective_equipment_status_name',
								]}
								remoteOperations={{
									pagination: true,
									sorting: true,
									filtering: true,
								}}
								// data={dataList || []}
								nameFile={'control_epp'}
							/>
						</CardBody>
					</Card>
				</Col>
			</Row>
		</React.Fragment>
	);
};

export default PersonalProtectiveEquipmentSupplyList;
